import { Type } from 'class-transformer';
import { RestaurantExplore } from '../domains/restaurant-explore';
import { TypeCategory } from '../domains/type-category';

export class TypeCategorySection {
  keys = [];
  titles: string[] = [];
  section: number;
  hasChain = false;
  hasRestaurants = false;
  isExample = false;

  @Type(() => TypeCategory)
  typeCategories: Array<TypeCategory> = [];

  active = false;

  get keysString() {
    return this.keys.join('-').replace(' ', '-');
  }

  get title() {
    return this.titles.join(' | ');
  }

  getNextRestaurant(restaurantId: number): RestaurantExplore | null {
    for (let catIndex = 0; catIndex < this.typeCategories.length; catIndex++) {
      const category = this.typeCategories[catIndex];

      for (let i = 0; i < category.restaurants.length; i++) {

        if (category.restaurants[i].id === restaurantId) {
          if (i + 1 < category.restaurants.length) {
            return category.restaurants[i + 1];
          }

          if (catIndex + 1 < this.typeCategories.length) {
            return this.typeCategories[catIndex + 1].restaurants[0] ?? category.restaurants[i];
          }

          return category.restaurants[i];
        }
      }
    }

    return null;
  }

  getFirstRestaurant(): RestaurantExplore | null {
    for (const category of this.typeCategories) {
      if (category.restaurants.length > 0) {
        return category.restaurants[0];
      }
    }

    return null;
  }
}
